export default {
  dataModel: {
    types: ['pair:Group'],
    list: {
      servers: ['@default']
    }
  }
};
